import React from 'react';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types';
import { InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

export const TextSearchField = props => {
    const {
        id,
        title,
        options,
        emptyValue,
        placeholder,
        error,
        errorText,
        helperText,
        required,
        disabled,
        inputValue,
        onBlur,
        onFocus,
        uiSchema
    } = props;

    const { classes = {} } = uiSchema;
    const onChange = ({ target: { value } }) => (
        props.onChange(id, value === '' ? emptyValue : value)
    );

    const additionalProps = {
        InputProps: {}
    };

    if (options.iconPlacement === 'start') {
        additionalProps.InputProps.startAdornment =
            <InputAdornment position="start">
                <SearchIcon />
            </InputAdornment>;
    } else if (options.iconPlacement === 'end') {
        additionalProps.InputProps.endAdornment =
            <InputAdornment position="end">
                <SearchIcon />
            </InputAdornment>;
    }

    if (title) {
        additionalProps.label = title;
    }

    return (
        <React.Fragment>
            <FormControl
                required={ required }
                error={ error }
                component="fieldset"
                classes={{
                    root: classes.fieldSet || ''
                }}
            >
                <TextField
                    id={ id }
                    classes={{
                        root: classes.textField || ''
                    }}
                    margin={ options.margin || 'normal' }
                    variant={ options.variant ? options.variant : 'outlined' }
                    onChange={ !disabled ? onChange : null }
                    placeholder={ placeholder }
                    error={ error }
                    required={ required }
                    disabled={ disabled }
                    value={ inputValue || '' }
                    onBlur={ onBlur && (event => onBlur({ id, value: event.target.value })) }
                    onFocus={ onFocus && (event => onFocus({ id, value: event.target.value })) }
                    { ...additionalProps }
                />
                { helperText ? <FormHelperText
                    classes={{
                        root: classes.helperContainer || ''
                    }}
                >{ helperText }</FormHelperText> : null }
                { errorText ? <FormHelperText
                    classes={{
                        root: classes.errorContainer || ''
                    }}
                >{ errorText }</FormHelperText> : null }
            </FormControl>
        </React.Fragment>
    );
};

TextSearchField.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    emptyValue: PropTypes.any,
    placeholder: PropTypes.any,
    error: PropTypes.bool,
    errorText: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.shape({
        variant: PropTypes.string,
        iconPlacement: PropTypes.oneOf(['start', 'end']),
        margin: PropTypes.oneOf(['none', 'normal', 'dense'])
    }),
    uiSchema: PropTypes.shape({
        classes: PropTypes.shape({
            fieldSet: PropTypes.string,
            textField: PropTypes.string,
            titleContainer: PropTypes.string,
            helperContainer: PropTypes.string,
            errorContainer: PropTypes.string
        })
    }),
    inputValue: PropTypes.string,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    helperText: PropTypes.string,
    onChange: PropTypes.func
};

TextSearchField.defaultProps = {
    title: '',
    emptyValue: '',
    placeholder: '',
    error: false,
    errorText: '',
    required: false,
    disabled: false,
    options: {
        variant: 'outlined',
        iconPlacement: 'start',
        margin: 'normal'
    },
    uiSchema: {},
    inputValue: '',
    helperText: ''
};
